export class SubmitTask {
  RequestNbr: string;
  Type: string;
  PendingComments: string;
  AdmittedCrimeNotFound: boolean;
  // dialogComment: string;
}



// WEBPACK FOOTER //
// ./src/models/submitTask.ts